module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "mui-cells shop"
  }, [(_vm.shop && _vm.shop.id) ? _c('section', {
    staticClass: "mui-cell"
  }, [_c('section', {
    staticClass: "mui-cell__hd"
  }, [_c('img', {
    staticClass: "avator",
    attrs: {
      "src": _vm.shop.headFigureUrlRebuild,
      "alt": ""
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "mui-cell__bd"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(_vm.shop.name) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "owner"
  }, [_vm._v("\n          店主姓名：" + _vm._s(_vm.shop.shopOwnerName) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("\n          店铺地址：" + _vm._s(_vm.shop.addressDetail) + "\n        ")])])]) : _c('section', {
    staticClass: "mui-cell no-shop"
  }, [_c('p', [_vm._v("\n        这个手机号还没有在美甲帮店务通开店或绑定到店铺！"), _c('br'), _vm._v("\n        没关系，支付后用这个手机号去注册登录就好啦~ "), _c('br'), _vm._v("\n        系统将自动为你激活账户！\n      ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.production || _vm.production.id) ? _c('section', {
    staticClass: "mui-cells production"
  }, [_c('section', {
    staticClass: "mui-cell"
  }, [_c('section', {
    staticClass: "mui-cell__bd"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.production.name) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          " + _vm._s(_vm.production.desc) + "\n        ")])]), _vm._v(" "), _c('section', {
    staticClass: "mui-cell__ft"
  }, [_c('span', {
    staticClass: "origin"
  }, [_vm._v("\n          ¥" + _vm._s(_vm._f("money")(_vm.production.originalPrice)) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v("\n          ¥" + _vm._s(_vm._f("money")(_vm.production.salePrice)) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "mui-cells payment"
  }, _vm._l((_vm.payments), function(payment) {
    return _c('a', {
      staticClass: "mui-cell",
      on: {
        "click": function($event) {
          _vm.selectedPayment(payment)
        }
      }
    }, [_c('section', {
      staticClass: "mui-cell__hd"
    }, [_c('i', {
      staticClass: "icon",
      class: payment.icon
    })]), _vm._v(" "), _c('section', {
      staticClass: "mui-cell__bd"
    }, [_vm._v("\n        " + _vm._s(payment.desc) + "\n      ")]), _vm._v(" "), _c('section', {
      staticClass: "mui-cell__ft"
    }, [_c('span', {
      staticClass: "checker",
      class: {
        'is-selected': payment.id === _vm.paymentId
      }
    }, [_c('span')])])])
  })), _vm._v(" "), _c('section', {
    staticClass: "alipy-form",
    domProps: {
      "innerHTML": _vm._s(_vm.alipyFrom)
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "pay"
  }, [_c('section', {
    staticClass: "price"
  }, [_vm._v("\n      合计：\n      "), _c('span', {
    staticClass: "total"
  }, [_vm._v("\n        ¥" + _vm._s(_vm._f("money")(_vm.production.salePrice)) + "\n      ")])]), _vm._v(" "), _c('a', {
    staticClass: "button_primary button",
    class: {
      'is-loading': _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.pay()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.payText) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mui-cells__title"
  }, [_c('i', {
    staticClass: "icon icon-cut"
  }), _vm._v(" "), _c('span', [_vm._v("已选择商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mui-cells__title"
  }, [_c('i', {
    staticClass: "icon icon-cut"
  }), _vm._v(" "), _c('span', [_vm._v("支付方式")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-354ff627!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Pay.vue
// module id = 93
// module chunks = 2